import {
	Card,
	Row,
	Col,
	//  Input, Select, Button
} from 'antd';
import { useState, useEffect } from 'react';
import { useAppSelector } from '../../methods/redux/hooks';

const FluidReport = () => {
	const { fluid } = useAppSelector((store) => store.general);
	// const [state, setState] = useState({
	// 	address: '',
	// 	description: '',
	// 	chainType: '',
	// });
	const [formattedData, setFormattedData] = useState([
		{ id: 1, property: 'Loading...', value: '0' },
	]);

	// Effect to update the formatted data when fluid data is available
	useEffect(() => {
		if (fluid && Object.keys(fluid).length > 0) {
			const newFormattedData = Object.keys(fluid).map((key, index) => ({
				id: index + 1,
				property: key,
				value: fluid[key],
			}));
			setFormattedData(newFormattedData);
		}
	}, [fluid]);
	// type FormattedDataItem = {
	// 	id: number;
	// 	property: string;
	// 	value: string; // Or `any` if the values can vary in type
	// };

	// const formattedData: FormattedDataItem[] = Object.keys(fluid).map(
	// 	(key, index) => ({
	// 		id: Number(index + 1),
	// 		property: key,
	// 		value: fluid[key],
	// 	})
	// );
	// const items = [
	// 	{
	// 		key: 'evm',
	// 		label: 'evm',
	// 	},
	// 	{
	// 		key: 'ton',
	// 		label: 'ton',
	// 	},
	// 	{
	// 		key: 'tron',
	// 		label: 'tron',
	// 	},
	// 	{
	// 		key: 'solana',
	// 		label: 'solana',
	// 	},
	// ];
	return (
		<div>
			<Card id="daily-apy">
				<h2>Fluid Report</h2>
				{/* <div>
					<p>Custodial Wallet Address</p>
					<Input
						style={{ width: '50%' }}
						value={state.address}
						onChange={(e) => setState({ ...state, address: e.target.value })}
					/>
				</div>
				<div>
					<Select
						defaultValue={state.chainType}
						style={{ width: '50%', marginTop: '10px' }}
						onChange={(value) => setState({ ...state, chainType: value })}
					>
						{items.map((i: any) => (
							<Select.Option key={i.key} value={i.key}>
								{i.label}
							</Select.Option>
						))}
					</Select>
				</div> */}

				{/* <div>
					<Button type="default">
						<a
							href=" https://autoyield.xend.africa/"
							target="_blank"
							rel="noopener noreferrer"
						>
							Submit
						</a>
					</Button>
				</div> */}
				<p>Displays the fluid reports</p>
				<br />
				<Row gutter={[1, 1]}>
					<Col span={4}>
						<div
							style={{
								background: '#fffff',
								padding: '10px',
								textAlign: 'left',
								border: '1px solid grey',
							}}
						>
							<strong>Title</strong>
						</div>
					</Col>
					<Col span={4}>
						<div
							style={{
								background: '#fffff',
								padding: '10px',
								textAlign: 'left',
								border: '1px solid grey',
							}}
						>
							<strong>Value</strong>
						</div>
					</Col>
					<Col span={4}>
						<div
							style={{
								background: '#fffff',
								padding: '10px',
								textAlign: 'left',
								border: '1px solid grey',
							}}
						>
							<strong>Currency Value</strong>
						</div>
					</Col>
				</Row>
				{formattedData.map((item) => (
					<Row gutter={[1, 1]} key={item.id}>
						<Col span={4}>
							<div
								style={{
									background: '#fffff',
									padding: '10px',
									textAlign: 'left',
									border: '1px solid grey',
								}}
							>
								{item.property}
							</div>
						</Col>
						<Col span={4}>
							<div
								style={{
									background: '#fffff',
									padding: '10px',
									textAlign: 'left',
									border: '1px solid grey',
								}}
							>
								<strong
									style={{
										color:
											// item.property === 'totalBalance' ||
											item.property === 'totalAssets' ? 'green' : 'inherit',
									}}
								>
									{Number(item.value).toLocaleString('en-US', {
										minimumFractionDigits: 3,
										maximumFractionDigits: 3,
									})}
								</strong>
							</div>
						</Col>
						<Col span={4}>
							<div
								style={{
									background: '#fffff',
									padding: '10px',
									textAlign: 'left',
									border: '1px solid grey',
								}}
							>
								<strong
									style={{
										marginRight: '20px',
										color:
											// item.property === 'totalBalance' ||
											item.property === 'totalAssets' ? 'green' : 'inherit',
									}}
								>
									{(Number(item.value) / 1000000).toLocaleString('en-US', {
										minimumFractionDigits: 3,
										maximumFractionDigits: 3,
									})}
									&nbsp;USDC
								</strong>
							</div>
						</Col>
					</Row>
				))}
			</Card>
		</div>
	);
};

export default FluidReport;
